const DASH_QRCODE_URL = window.location.origin === 'https://tos.thirky.com'
  ? 'https://dashqrcode.thirky.com'
  : 'http://192.168.0.182:3001';

export default DASH_QRCODE_URL